import { IPublicityBannerProps } from "@gisce/oficina-virtual-components";

export const isCoupon = (object: any): object is IPublicityBannerProps["dataProps"] => {
	return 'title' in object && 'description' in object;
}